module.exports = __webpack_public_path__ + "img/janssen.63b0a4bc.png";